import { FrameRange } from 'content-creation-common/models';
import Frame from '../Frame';

import { isNumber } from '../../util/numbers';
import { isNil, isNotNil } from '../../util/object';
import { isEmpty as isEmptyArray } from '../../util/array';

export default class Chapter {
  _baseDuration;
  _frameRange;
  _frameEnd;
  _frameStart;
  _index;
  _length;
  _shots;

  constructor(index, frameStart, frameEnd, shots) {
    if (isNumber(frameStart) && isNumber(frameEnd)) {
      const frameRange = new FrameRange(frameStart, frameEnd);
      this._frameRange = frameRange;
      this._length = frameRange.length;
      this._frameEnd = frameEnd;
      this._frameStart = frameStart;
      this._shots = shots;
      this._baseDuration = Frame.frameToSeconds(frameRange.length);
    }
    this._index = index;
  }

  get numUnskippedFrames() {
    if (isEmptyArray(this._shots)) {
      return this._length;
    }
    let skippedFrames = 0;
    this._shots.forEach((shot) => {
      if (
        isNotNil(shot) &&
        isNotNil(shot.meta) &&
        shot.meta.shotSkipped === true
      ) {
        const { endFrame, startFrame } = shot;
        if (isNil(endFrame) || isNil(startFrame)) return;
        const shotFrameRange = new FrameRange(startFrame, endFrame);
        skippedFrames += shotFrameRange.length;
      }
    });
    return Math.max(this._length - skippedFrames, 0);
  }

  get duration() {
    return Frame.frameToSeconds(this.numUnskippedFrames);
  }

  get frameEnd() {
    return this._frameEnd;
  }

  get frameRange() {
    return this._frameRange;
  }

  get frameStart() {
    return this._frameStart;
  }

  get index() {
    return this._index;
  }

  get length() {
    return this._length;
  }

  /**
   * Checks if object is an instance of Chapter
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isChapter(inputObject) {
    return inputObject instanceof Chapter;
  }
}
